// Planet Photography Shader
uniform vec3 uColorLow;
uniform vec3 uColorHigh;

#include ../includes/simplexNoise4d.glsl

varying vec2 vUv;
varying float vWobble;

void main()
{
    float colorMix = smoothstep(- 1.0, 1.0, vWobble);
    csm_DiffuseColor.rgb = mix(uColorLow, uColorHigh, colorMix);
}